document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('#infiniteProducts');
  const pagination = document.querySelector('#infinitePagination');

  if (!container || !pagination) return;

  let loading = false;

  // Figure out what page we’re currently on (default 1)
  let currentPage = (function () {
    const match = window.location.search.match(/page=(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  })();

  function getNextPageUrl() {
    const links = Array.from(pagination.querySelectorAll('a[href*="page="]'));
    if (!links.length) return null;

    // Build a list of { page, url } from all page links
    const pageLinks = links
      .map((a) => {
        const m = a.href.match(/page=(\d+)/);
        if (!m) return null;
        return { page: parseInt(m[1], 10), url: a.href };
      })
      .filter(Boolean)
      // Only consider pages AFTER the current one
      .filter((obj) => obj.page > currentPage)
      .sort((a, b) => a.page - b.page);

    // Smallest page number greater than current = true “next” page
    return pageLinks.length ? pageLinks[0].url : null;
  }

  async function loadNextPage() {
    if (loading) return;

    const nextUrl = getNextPageUrl();
    if (!nextUrl) {
      // No more pages: stop watching
      observer.disconnect();
      return;
    }

    loading = true;

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts = doc.querySelector('#infiniteProducts');
      const newPagination = doc.querySelector('#infinitePagination');

      if (newProducts) {
        container.insertAdjacentHTML('beforeend', newProducts.innerHTML);
      }

      if (newPagination) {
        pagination.innerHTML = newPagination.innerHTML;
      } else {
        pagination.remove();
        observer.disconnect();
      }

      // Update currentPage based on the URL we just loaded
      const m = nextUrl.match(/page=(\d+)/);
      if (m) {
        currentPage = parseInt(m[1], 10);
      }
    } catch (e) {
      console.error('Infinite scroll error:', e);
    }

    loading = false;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadNextPage();
      }
    });
  });

  observer.observe(pagination);
});
